var map = {
	"./atendimentos/atendimentos/router/routes.js": "a9a6",
	"./atendimentos/auxiliares/assuntos/router/routes.js": "4c6d",
	"./atendimentos/auxiliares/campos_extras/router/routes.js": "66e5",
	"./atendimentos/auxiliares/formas/router/routes.js": "328d",
	"./atendimentos/auxiliares/situacoes/router/routes.js": "07d3",
	"./shared/auxiliares/ajuda/router/routes.js": "8d08",
	"./shared/auxiliares/atualizacoes/router/routes.js": "795a",
	"./shared/auxiliares/notificacoes/router/routes.js": "0168",
	"./shared/auxiliares/termos/router/routes.js": "d173",
	"./shared/auxiliares/videos_tutoriais/router/routes.js": "2cee",
	"./shared/cadastros/auxiliares/campos_extras/router/routes.js": "02ba",
	"./shared/cadastros/auxiliares/tipos_contatos/router/routes.js": "a848",
	"./shared/cadastros/auxiliares/tipos_enderecos/router/routes.js": "6857",
	"./shared/cadastros/clientes/router/routes.js": "e2ca",
	"./shared/cadastros/fornecedores/router/routes.js": "24c0",
	"./shared/cadastros/funcionarios/router/routes.js": "a4b3",
	"./shared/cadastros/transportadoras/router/routes.js": "dd07",
	"./shared/configuracoes/avisos_email/router/routes.js": "9d46",
	"./shared/configuracoes/backup_dados/router/routes.js": "a744",
	"./shared/configuracoes/certificado_digital/router/routes.js": "52e0",
	"./shared/configuracoes/dominios/router/routes.js": "3acd",
	"./shared/configuracoes/exclusao_dados/router/routes.js": "0b09",
	"./shared/configuracoes/gerais/router/routes.js": "86c1",
	"./shared/configuracoes/grupos_usuarios/router/routes.js": "bd89",
	"./shared/configuracoes/lojas/router/routes.js": "ecf7",
	"./shared/configuracoes/marca_empresa/router/routes.js": "667f",
	"./shared/configuracoes/modelos_emails/router/routes.js": "9343",
	"./shared/configuracoes/permissoes/router/routes.js": "4a4b",
	"./shared/configuracoes/planos/router/routes.js": "6255",
	"./shared/configuracoes/usuarios/router/routes.js": "7fdf",
	"./shared/erros/router/routes.js": "2b05",
	"./shared/relatorios/usuarios_logs/router/routes.js": "4983"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "80b1";